import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { HelperService, ToastrService } from '../services/index.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    public helperService: HelperService,
    private router: Router,
    private toastrService: ToastrService,
  ) {
  }
  userObj: any;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.userObj = this.helperService.getLocalStorage('userObj');
    if (this.userObj && Object.keys(this.userObj).length > 0) {
      return true;
    }
    else {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
